import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent {
  // mandatory
  @Input() label: string;
  @Input() control = new FormControl();
  @Input() fieldName: string;
  // not obligatory
  @Input() maxlength = 100;
  @Input() placeholder: string;
  @Input() hint: string;
  @Input() type = 'text';
  @Input() showIcon = true;
  @Input() mask: string;
  @Input() height = 40;
  @Input() disabled: boolean;
  @Output() blured = new EventEmitter();
  @Output() inputed = new EventEmitter();
  @Output() keyupped = new EventEmitter();

}
